import { Redirect } from './checkoutState';

const getData = (parameters: { name: string; value: string }[]) =>
  Object.fromEntries(parameters.map(({ name, value }) => [name, value]));

export const getQueryParamsFromUrl = (url: string) => {
  const urlSearchParams = new URL(url).searchParams;
  return Array.from(urlSearchParams.entries()).map(([key, value]) => ({
    name: key,
    value
  }));
};

const redirect = ({ method, url, parameters }: Redirect) => {
  try {
    const data = parameters && getData(parameters);

    if (method === 'GET') {
      const ongoingRedirectList = JSON.parse(sessionStorage.getItem('ongoingRedirects') || '[]');
      const hasOngoingRedirects = ongoingRedirectList.includes(url);

      if (hasOngoingRedirects) {
        return;
      }

      ongoingRedirectList.push(url);

      if (!url.includes('waitForPaymentConfirmation')) {
        sessionStorage.setItem('ongoingRedirects', JSON.stringify(ongoingRedirectList));
      }

      top!.location.href = data ? `${url}?${new URLSearchParams(data).toString()}` : url;
    } else if (method === 'POST') {
      const form = document.createElement('form');
      form.method = method;
      form.action = url;
      if (data) {
        Object.entries(data).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });
      }
      top!.document.body.appendChild(form);
      form.submit();
    }
  } catch (error) {
    console.log(error);
  }
};

export default redirect;
